import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify, warningnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typependaftaran";
var post = "/typependaftaran";
export const actGetDataTyperegistration = () => {
  return (dispatch) => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPEREGISTRATION" });
    CONNECTION(config)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEREGISTRATION",
            message: "Success get data",
            data: data,
            code: status,
          });
        }
        return dispatch({ type: "ERROR_TYPEREGISTRATION", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEREGISTRATION",
          message: "Network error..",
        });
      });
  };
};

export const actPostDataTyperegistration = (params) => {
  return (dispatch) => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPEREGISTRATION" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type registration has been created");
          dispatch(
            __openModal({ modal: "MODAL_ADD_TYPEREGISTRATION", open: false })
          );
          return dispatch(actGetDataTyperegistration());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEREGISTRATION", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEREGISTRATION",
          message: "Network error..",
        });
      });
  };
};

export const actUpdateDataTyperegistration = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPEREGISTRATION" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type registration has been edit");
          dispatch(
            __openModal({ modal: "MODAL_EDIT_TYPEREGISTRATION", open: false })
          );
          return dispatch(actGetDataTyperegistration());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEREGISTRATION", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEREGISTRATION",
          message: "Network error..",
        });
      });
  };
};

export const actDetailDataTyperegistration = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPEREGISTRATION" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEREGISTRATION",
            message: "Success get data",
          });
        }
        return dispatch({ type: "ERROR_TYPEREGISTRATION", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEREGISTRATION",
          message: "Network error..",
        });
      });
  };
};

export const actDeleteDataTyperegistration = (params) => {
  return (dispatch) => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPEREGISTRATION" });
    CONNECTION(config)
      .then((response) => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type registration has been deleted");
          return dispatch(actGetDataTyperegistration());
        }
        warningnotify(response.message);
        return dispatch({ type: "ERROR_TYPEREGISTRATION", message: "failed" });
      })
      .catch((response) => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEREGISTRATION",
          message: "Network error..",
        });
      });
  };
};
